<template>
  <div>
    <Header />
    <div class="content-web container">
      <div class="row form-submit">
        <div class="col-12 col-sm-12 col-md-3 col-lg-3">
          <div class="sku_new_submission" v-if="ipTypeData">
            <div class="new_submission_img">
              <img
                id="new_submission_detail"
                v-bind:src="ipTypeData.thumb"
                alt="Title Image"
                style="width : 55px; height:55px;"
              />
            </div>
            <div class="new_submission_title">
              <p id="new_submission_title_detail">{{ipTypeData.name}}</p>
              <p>
                Trạng thái:
                <span id="new_submission_title_status">{{ ipStatus }}</span>
              </p>
            </div>
          </div>
          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link tab active"
              id="v-pills-intro-tab"
              data-toggle="pill"
              href="#v-pills-intro"
              role="tab"
              aria-controls="v-pills-home"
              aria-selected="true"
            >
              <span class="case_study_step">1</span>Thông tin tổng quát
              <span class="star_validate">*</span>
            </a>
            <a
              class="nav-link tab"
              id="v-pills-detail-tech-tab"
              data-toggle="pill"
              href="#v-pills-detail"
              role="tab"
              aria-controls="v-pills-detail"
              aria-selected="false"
            >
              <span class="case_study_step">2</span>Nội dung sáng kiến
              <span class="star_validate">*</span>
            </a>
            <a
              class="nav-link tab"
              id="v-pills-analysis-tab"
              data-toggle="pill"
              href="#v-pills-analysis"
              role="tab"
              aria-controls="v-pills-analysis"
              aria-selected="false"
            >
              <span class="case_study_step">3</span>Phân tích sáng kiến
              <span class="star_validate">*</span>
            </a>
            <a
              class="nav-link tab"
              id="v-pills-other-tab"
              data-toggle="pill"
              href="#v-pills-other"
              role="tab"
              aria-controls="v-pills-other"
              aria-selected="false"
            >
              <span class="case_study_step">4</span>Thông tin khác
              <span class="star_validate">*</span>
            </a>
          </div>
        </div>

        <div class="col-12 col-sm-12 col-md-9 col-lg-9">
          <div class="form-right clearfix mb-5" style="background-color: #fff;">
            <!-- buttom -->
            <div class="form-control-top">
              <button
                type="button"
                class="btn btn-outline-primary"
                @click="submitIp(true)"
                :disabled="processing"
              >LƯU BẢN NHÁP</button>
              <button
                type="button"
                class="btn btn-outline-primary"
                @click="$router.push({name: cancelPageName})"
              >HỦY BỎ</button>
              <button
                type="button"
                class="btn btn-primary mt-1 mt-sm-0 mt-md-0 mt-lg-0 mt-xl-0"
                @click="submitIp(false)"
                :disabled="processing"
              >ĐĂNG KÝ</button>
            </div>

            <!-- tab -->
            <div class="form-body pt-4">
              <div class="tab-content" id="v-pills-tabContent">
                <!-- <validation-observer ref="formSubmit"> -->
                <!-- Tab intro -->
                <div
                  class="tab-pane fade show active"
                  id="v-pills-intro"
                  role="tabpanel"
                  aria-labelledby="v-pills-intro-tab"
                >
                  <validation-observer ref="formIntro">
                    <validation-provider
                      :rules="{ required: true, min: 6, maxWords: 13}"
                      v-slot="validationContext"
                    >
                      <b-form-group id="input-name-group" label-for="input-name">
                        <template slot="label">
                          Tên sáng kiến
                          <span class="text-danger font-italic note">*</span>
                        </template>
                        <b-form-input
                          id="input-name"
                          name="input-name"
                          placeholder="Tên gọi mô tả ngắn gọn sáng kiến"
                          v-model="form.title"
                          :state="getValidationState(validationContext)"
                          aria-describedby="input-name"
                        ></b-form-input>

                        <b-form-invalid-feedback id="input-name">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider
                      :rules="{ required: true, min: 6, maxWords: 50}"
                      v-slot="validationContext"
                    >
                      <b-form-group id="input-intro-group" label-for="input-intro">
                        <template slot="label">
                          Giới thiệu về sáng kiến
                          <span class="text-danger font-italic note">*</span>
                        </template>
                        <b-form-textarea
                          id="input-intro"
                          name="input-intro"
                          placeholder="Giới thiệu ngắn gọn về sáng kiến"
                          v-model="form.intro"
                          :state="getValidationState(validationContext)"
                          aria-describedby="input-intro"
                        ></b-form-textarea>

                        <b-form-invalid-feedback
                          id="input-naintrome"
                        >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider :rules="{ required: true}" v-slot="validationContext">
                      <div class="form-group">
                        <label class="required">
                          Công ty thành viên
                          <span
                            class="text-danger font-italic note"
                          >(chọn đúng công ty thành viên)</span>
                        </label>
                        <b-form-select
                          v-model="form.companyCode"
                          :options="fptCompany"
                          value-field="code"
                          text-field="name"
                          :state="getValidationState(validationContext)"
                          @blur="getValidationState(validationContext)"
                        ></b-form-select>
                        <b-form-invalid-feedback
                          id="input-companyCode"
                        >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </div>
                    </validation-provider>

                    <validation-provider :rules="{ required: true}" v-slot="validationContext">
                      <b-form-group id="input-unit-group" label="Đơn vị" label-for="input-unit">
                        <template slot="label">
                          Đơn vị
                          <span class="text-danger font-italic note">*</span>
                        </template>
                        <b-form-input
                          id="input-unit"
                          name="input-unit"
                          v-model="form.companyUnit"
                          :state="getValidationState(validationContext)"
                          aria-describedby="input-unit"
                        ></b-form-input>

                        <b-form-invalid-feedback id="input-unit">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider :rules="{ required: true}" v-slot="validationContext">
                      <b-form-group id="input-department-group" label-for="input-department">
                        <template slot="label">
                          Phòng/ban
                          <span class="text-danger font-italic note">*</span>
                        </template>
                        <b-form-input
                          id="input-department"
                          name="input-department"
                          v-model="form.companyDepartment"
                          :state="getValidationState(validationContext)"
                          aria-describedby="input-department"
                        ></b-form-input>
                        <b-form-invalid-feedback
                          id="input-department"
                        >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider
                      :rules="{ required: true, min: 6}"
                      v-slot="validationContext"
                    >
                      <b-form-group id="input-author-group" label-for="input-author">
                        <template slot="label">
                          Tác giả/ Nhóm tác giả
                          <span class="text-danger font-italic note">*</span>
                        </template>
                        <b-form-input
                          id="input-author"
                          name="input-author"
                          placeholder="Ghi đầy đủ họ tên tác giả, các đồng tác giả hoặc tên người đại diện cho nhóm tác giả."
                          v-model="form.author"
                          :state="getValidationState(validationContext)"
                          aria-describedby="input-author"
                        ></b-form-input>

                        <b-form-invalid-feedback id="input-author">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <br />
                    <div class="row">
                      <div class="col-lg-12">
                        <label class="font-weight-bold">Liên hệ:</label>
                      </div>

                      <div class="col-lg-4 col-md-4 col-sm-12">
                        <validation-provider :rules="{ required: true}" v-slot="validationContext">
                          <b-form-group
                            id="input-author_name-group"
                            label="Tên"
                            label-for="input-author_name"
                          >
                            <template slot="label">
                              Tên
                              <span class="text-danger font-italic note">*</span>
                            </template>
                            <b-form-input
                              id="input-author_name"
                              name="input-author_name"
                              v-model="form.contactName"
                              :state="getValidationState(validationContext)"
                              aria-describedby="input-author_name"
                            ></b-form-input>

                            <b-form-invalid-feedback
                              id="input-author_name"
                            >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </div>

                      <div class="col-lg-4 col-md-4 col-sm-12">
                        <validation-provider
                          :rules="{ required: true, phoneNumber: true}"
                          v-slot="validationContext"
                        >
                          <b-form-group
                            id="input-author_phone-group"
                            label-for="input-author_phone"
                          >
                            <template slot="label">
                              SĐT
                              <span class="text-danger font-italic note">*</span>
                            </template>
                            <b-form-input
                              id="input-author_phone"
                              name="input-author_phone"
                              v-model="form.contactPhone"
                              :state="getValidationState(validationContext)"
                              aria-describedby="input-author_phone"
                            ></b-form-input>

                            <b-form-invalid-feedback
                              id="input-author_phone"
                            >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </div>

                      <div class="col-lg-4 col-md-4 col-sm-12">
                        <validation-provider
                          :rules="{ required: true, email: true, min: 6}"
                          v-slot="validationContext"
                        >
                          <b-form-group
                            id="input-author_email-group"
                            label-for="input-author_email"
                          >
                            <template slot="label">
                              Email
                              <span class="text-danger font-italic note">*</span>
                            </template>
                            <b-form-input
                              id="input-author_email"
                              name="input-author_email"
                              v-model="form.contactEmail"
                              :state="getValidationState(validationContext)"
                              aria-describedby="input-author_email"
                            ></b-form-input>

                            <b-form-invalid-feedback
                              id="input-author_email"
                            >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </div>

                      <div class="col-lg-4 col-md-4 col-sm-12">
                        <label class="pt-2">Thời điểm áp dụng thực tế <span class="text-danger font-italic note">*</span></label>
                      </div>

                      <div class="col-lg-4 col-md-4 col-sm-12">
                        <validation-provider :rules="{ required: true}" v-slot="validationContext">
                          <b-form-group id="input-date-input" label-for="input-date-input">
                            <b-form-datepicker
                              placeholder="Date apply"
                              id="date-input"
                              v-model="applyDate"
                              :state="getValidationState(validationContext)"
                              :date-disabled-fn="disabledTimeApply"
                              class="mb-2"
                              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                            ></b-form-datepicker>
                            <b-form-invalid-feedback
                              id="input-author_email"
                            >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </div>

                      <div class="col-lg-4 col-md-4 col-sm-12">
                        <label>
                          <span
                            class="text-danger font-italic note"
                          >(Lưu ý: phải trong 12 tháng trở lại đây)</span>
                        </label>
                      </div>
                    </div>
                  </validation-observer>
                </div>

                <!-- tab detail -->
                <div
                  class="tab-pane fade"
                  id="v-pills-detail"
                  role="tabpanel"
                  aria-labelledby="v-pills-detail-tab"
                >
                  <validation-observer ref="formDetail">
                    <validation-provider
                      :rules="{ required: true, min: 6}"
                      v-slot="validationContext"
                    >
                      <b-form-group id="input-status_before-group" label-for="input-status_before">
                        <template slot="label">
                          Tình trạng trước khi có sáng kiến
                          <span
                            class="text-danger font-italic note"
                          >*</span>
                        </template>
                        <b-form-textarea
                          id="input-status_before"
                          name="input-status_before"
                          placeholder="Nêu hiện trạng trước khi áp dụng giải pháp mới; Phân tích ưu nhược điểm của giải pháp cũ"
                          v-model="form.statusBefore"
                          :state="getValidationState(validationContext)"
                          aria-describedby="input-status_before"
                        ></b-form-textarea>

                        <b-form-invalid-feedback
                          id="input-status_before"
                        >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider
                      :rules="{ required: true, min: 6}"
                      v-slot="validationContext"
                    >
                      <b-form-group id="input-purpose-group" label-for="input-purpose">
                        <template slot="label">
                          Mục đích của giải pháp
                          <span class="text-danger font-italic note">*</span>
                        </template>
                        <b-form-textarea
                          id="input-purpose"
                          name="input-purpose"
                          placeholder="Nên vấn đề cần giải quyết"
                          v-model="form.solutionPurpose"
                          :state="getValidationState(validationContext)"
                          aria-describedby="input-purpose"
                        ></b-form-textarea>

                        <b-form-invalid-feedback
                          id="input-purpose"
                        >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider
                      :rules="{ required: true, min: 6}"
                      v-slot="validationContext"
                    >
                      <b-form-group id="input-content-group" label-for="input-content">
                        <template slot="label">
                          Nội dung giải pháp đề nghị công nhận sáng kiến
                          <span
                            class="text-danger font-italic note"
                          >*</span>
                        </template>
                        <b-form-textarea
                          id="input-content"
                          name="input-content"
                          placeholder="Nêu cách thức thực hiện, các bước thực hiện của giải pháp mới một cách cụ thể, rõ ràng cũng như các điều kiện cần thiết để áp dụng giải pháp"
                          v-model="form.ideaSuggestApplyContent"
                          :state="getValidationState(validationContext)"
                          aria-describedby="input-content"
                        ></b-form-textarea>

                        <b-form-invalid-feedback
                          id="input-content"
                        >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </validation-observer>
                </div>

                <!-- tab analysis -->
                <div
                  class="tab-pane fade"
                  id="v-pills-analysis"
                  role="tabpanel"
                  aria-labelledby="v-pills-analysis-tab"
                >
                  <validation-observer ref="formAnalysis">
                    <validation-provider
                      :rules="{ required: true, min: 6}"
                      v-slot="validationContext"
                    >
                      <b-form-group id="input-effectiveness-group" label-for="input-effectiveness">
                        <template slot="label">
                          Tính hiệu quả
                          <span class="text-danger font-italic note">*</span>
                        </template>
                        <b-form-textarea
                          id="input-effectiveness"
                          name="input-effectiveness"
                          placeholder="Mô tả tính hiệu quả của sáng kiến: hiệu quả kinh tế, hiệu quả hoạt động và phân tích nhận định của tác giả vì sao sáng kiến có hiệu quả này."
                          v-model="form.effective"
                          :state="getValidationState(validationContext)"
                          aria-describedby="input-effectiveness"
                        ></b-form-textarea>

                        <b-form-invalid-feedback
                          id="input-effectiveness"
                        >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider
                      :rules="{ required: true, min: 6}"
                      v-slot="validationContext"
                    >
                      <b-form-group id="input-novelty-group" label-for="input-novelty">
                        <template slot="label">
                          Tính mới
                          <span class="text-danger font-italic note">*</span>
                        </template>
                        <b-form-textarea
                          id="input-novelty"
                          name="input-novelty"
                          placeholder="Chỉ ra tính mới, sự khác biệt của giải pháp mới so với giải pháp cũ."
                          v-model="form.novelty"
                          :state="getValidationState(validationContext)"
                          aria-describedby="input-novelty"
                        ></b-form-textarea>

                        <b-form-invalid-feedback
                          id="input-novelty"
                        >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider
                      :rules="{ required: true, min: 6}"
                      v-slot="validationContext"
                    >
                      <b-form-group id="input-creativity-group" label-for="input-creativity">
                        <template slot="label">
                          Tính sáng tạo
                          <span class="text-danger font-italic note">*</span>
                        </template>
                        <b-form-textarea
                          id="input-creativity"
                          name="input-creativity"
                          placeholder="Giải thích cụ thể về quá trình nghiên cứu, sáng tạo để hình thành sáng kiến."
                          v-model="form.creativity"
                          :state="getValidationState(validationContext)"
                          aria-describedby="input-creativity"
                        ></b-form-textarea>

                        <b-form-invalid-feedback
                          id="input-creativity"
                        >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider>
                      <b-form-group id="input-next_step-group" label-for="input-next_step">
                        <template slot="label">Dự định tiếp theo</template>
                        <b-form-textarea
                          id="input-next_step"
                          name="input-next_step"
                          v-model="form.nextPlan"
                          aria-describedby="input-next_step"
                        ></b-form-textarea>
                      </b-form-group>
                    </validation-provider>
                  </validation-observer>
                </div>

                <!-- tab other -->
                <div
                  class="tab-pane fade"
                  id="v-pills-other"
                  role="tabpanel"
                  aria-labelledby="v-pills-other-tab"
                >
                  <validation-observer ref="formOther">
                    <validation-provider
                      :rules="{ required: true, min: 6}"
                      v-slot="validationContext"
                    >
                      <b-form-group id="input-security_info-group" label-for="input-security_info">
                        <template slot="label">
                          Các thông tin cần được bảo mật
                          <span class="text-danger font-italic note">*</span>
                        </template>
                        <b-form-textarea
                          id="input-security_info"
                          name="input-security_info"
                          placeholder="Nếu có yêu cầu bảo mật, VD: Quy trình, bản vẽ thiết kế,.."
                          v-model="form.securityContent"
                          :state="getValidationState(validationContext)"
                          aria-describedby="input-security_info"
                        ></b-form-textarea>

                        <b-form-invalid-feedback
                          id="input-security_info"
                        >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider
                      :rules="{ required: true, min: 6}"
                      v-slot="validationContext"
                    >
                      <b-form-group
                        id="input-conditions_apply-group"
                        label-for="input-conditions_apply"
                      >
                        <template slot="label">
                          Các điều kiện cần thiết để áp dụng sáng kiến
                          <span
                            class="text-danger font-italic note"
                          >*</span>
                        </template>
                        <b-form-textarea
                          id="input-conditions_apply"
                          name="input-conditions_apply"
                          placeholder="Trình độ chuyên môn, cơ sở vật chất,…"
                          v-model="form.ideaCondition"
                          :state="getValidationState(validationContext)"
                          aria-describedby="input-conditions_apply"
                        ></b-form-textarea>

                        <b-form-invalid-feedback
                          id="input-conditions_apply"
                        >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <div class="form-group">
                      <label>File đính kèm</label>
                      <vue-dropzone
                        style="border: 1px dashed #1ab394"
                        id="file"
                        :destroyDropzone="false"
                        :options="optionsUploadFile"
                        :useCustomSlot="true"
                        ref="fileAttachment"
                        @vdropzone-success="onUploadFileSuccess"
                        @vdropzone-removed-file="onRemoveFile"
                      >
                        <div class="dropzone-custom-content">
                          <h4 class="dropzone-custom-title">Chọn file.</h4>
                        </div>
                      </vue-dropzone>
                    </div>

                    <div class="form-group">
                      <label>Ảnh đại diện sáng kiến</label>
                      <vue-dropzone
                        style="border: 1px dashed #1ab394"
                        id="fileSlideShow"
                        :destroyDropzone="false"
                        :options="optionsUploadSlideShow"
                        :useCustomSlot="true"
                        ref="fileSlideShow"
                        @vdropzone-success="onUploadSlideShowSuccess"
                        @vdropzone-removed-file="onRemoveSlideShow"
                      >
                        <div class="dropzone-custom-content">
                          <h4 class="dropzone-custom-title">Chọn ảnh.</h4>
                        </div>
                      </vue-dropzone>
                    </div>

                    <validation-provider :rules="{ required: true}" v-slot="validationContext">
                      <div class="form-group">
                        <b-form-checkbox
                          id="checkbox-commit"
                          v-model="form.commit"
                          name="checkbox-commit"
                          class="commit"
                          :state="getValidationState(validationContext)"
                        >
                          Tôi/Chúng tôi cam kết:
                          <br />
                          <span
                            class="font-italic"
                          >- Đã đọc và hiểu rõ các yêu cầu, tiêu chuẩn để được công nhận là Sáng kiến trong quy định về Chính sách khuyến khích sáng kiến nội bộ FPT.</span>
                          <br />
                          <span
                            class="font-italic"
                          >- Cung cấp các nội dung trung thực, chính xác trong bản đăng ký này.</span>
                          <br />
                          <span
                            class="font-italic"
                          >Nếu có thông tin nào không chính xác, tôi/chúng tôi xin hoàn toàn chịu trách nhiệm.</span>
                          <b-form-invalid-feedback
                            id="input-conditions_apply"
                          >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                        </b-form-checkbox>
                      </div>
                    </validation-provider>
                  </validation-observer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Vue from "vue";
import helper from "../../common/helper";
import * as CONFIG from "../../config/index";
import axios from "axios";
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import DatePicker from "vue2-datepicker";
import vue2Dropzone from "vue2-dropzone";
import { extend } from "vee-validate";
import { ipType } from "../const/ipType";
import ideaCommon from "../../common/idea";
import { removeFile } from "../../common/file";
import { getFileInfoList } from "../../common/file";
import moment from "moment";

const getAuthHeader = () => {
  let token = Vue.$cookies.get("accessToken");
  return { Authorization: `Bearer ${token}` };
};

extend("maxWords", {
  params: ["max"],
  validate: (value, { max }) => {
    if (!value) {
      return false;
    }

    let countWords = value.split(/\s+/);
    countWords = countWords.filter(p => p);
    if (countWords && countWords.length <= max) {
      return true;
    }
    return false;
  },
  message: "Bạn đã nhập quá số từ cho phép. Số lượng từ lớn nhất là {max}."
});

extend("phoneNumber", {
  params: null,
  validate: value => {
    if (!value) {
      return false;
    }
    const regex = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*/;
    if (value.match(regex)) {
      return true;
    }
    return false;
  },
  message: "Số điện thoại không hợp lệ."
});

const defaultData = function() {
  return {
    form: {
      id: undefined,
      title: "",
      summary: "",
      intro: "",
      attachments: "",
      type: "",
      author: "",
      companyCode: "",
      companyUnit: "",
      companyDepartment: "",
      contactName: "",
      contactPhone: "",
      contactEmail: "",
      applyDate: "",
      statusBefore: "",
      solutionPurpose: "",
      ideaSuggestApplyContent: "",
      effective: "",
      nextPlan: "",
      securityContent: "",
      ideaCondition: "",
      novelty: "",
      creativity: "",
      draft: false,
      slideShow: ""
    },
    fptCompany: [{ name: "Chọn công ty thành viên", code: "" }],
    cancelPageName: "HomePage",
    processing: false,
    optionsUploadFile: {
      url: `${CONFIG.API_URL}/file/upload?type=tbl_content`,
      thumbnailWidth: 150,
      maxFilesize: 100,
      addRemoveLinks: true,
      headers: getAuthHeader()
    },
    optionsUploadSlideShow: {
      url: `${CONFIG.API_URL}/file/upload?type=tbl_content`,
      thumbnailWidth: 150,
      maxFilesize: 100,
      addRemoveLinks: true,
      acceptedFiles: "image/*",
      headers: getAuthHeader()
    },
    ipStatus: "Bản nháp",
    ipTypeCode: "",
    ipTypeData: {},
    files: {
      attachments: [],
      slideShows: []
    },
    applyDate: null
  };
};

export default {
  name: "NewSubmit_IKhien",
  components: {
    Header,
    Footer,
    DatePicker,
    vueDropzone: vue2Dropzone
  },
  data() {
    return defaultData();
  },
  computed: {},
  created() {},
  async mounted() {
    const companys = await this.getAllCompany();
    this.fptCompany = this.fptCompany.concat(companys);
    let pageName = this.$route.name;
    if (pageName === "EditSubmission") {
      this.cancelPageName = "MySubmission";
      let id = this.$route.params.id;
      let data = await ideaCommon.getIdea(id);
      this.ipTypeCode = data.type;
      this.ipTypeData = ipType.find(p => p.code === data.type);

      this.form.id = data.id;
      this.form.title = data.title;
      this.form.summary = data.summary;
      this.form.intro = data.intro;
      this.form.attachments = data.attachments;
      this.form.type = data.type;
      this.form.author = data.author;
      this.form.companyCode = data.companyCode;
      this.form.companyUnit = data.companyUnit;
      this.form.companyDepartment = data.companyDepartment;
      this.form.contactName = data.contactName;
      this.form.contactPhone = data.contactPhone;
      this.form.contactEmail = data.contactEmail;
      this.applyDate = moment(data.applyDate).format("YYYY-MM-DD");
      this.form.statusBefore = data.statusBefore;
      this.form.solutionPurpose = data.solutionPurpose;
      this.form.ideaSuggestApplyContent = data.ideaSuggestApplyContent;
      this.form.effective = data.effective;
      this.form.nextPlan = data.nextPlan;
      this.form.securityContent = data.securityContent;
      this.form.ideaCondition = data.ideaCondition;
      this.form.novelty = data.novelty;
      this.form.creativity = data.creativity;
      this.form.slideShow = data.slideShow;

      let files = "";
      if (data.attachments && !data.slideShow) {
        files = data.attachments;
      } else if (!data.attachments && data.slideShow) {
        files = data.slideShow;
      } else if (data.attachments && data.slideShow) {
        files = data.attachments + "," + data.slideShow;
      }
      // const files = data.attachments;
      if (files) {
        const images = await this.getFileInfos(files);
        images &&
          images.forEach(file => {
            if (data.attachments.includes(file.id)) {
              this.setFileDropzone(file, "fileAttachment");
            }
            if (data.slideShow.includes(file.id)) {
              this.setFileDropzone(file, "fileSlideShow");
            }
          });
      }
    } else {
      let code = this.$route.params.type;
      this.ipTypeCode = code;
      this.ipTypeData = ipType.find(p => p.code === code);
      this.form.type = code;
    }
  },
  methods: {
    submitIp(isDraft) {
      Promise.all([
        this.$refs.formIntro.validate(),
        this.$refs.formDetail.validate(),
        this.$refs.formAnalysis.validate(),
        this.$refs.formOther.validate()
      ]).then(async res => {
        let isvalidate = res.find(p => p === false);
        if (isvalidate === false) {
          let indexError = res.findIndex(p => p === false);
          $(".tab-pane").removeClass("show active");
          $(".tab-pane")
            .eq(indexError)
            .addClass("show active");

          $(".nav-link.tab").removeClass("active");
          $(".nav-link.tab")
            .eq(indexError)
            .addClass("active");
          return;
        } else if (!this.form.commit) {
          delete this.form.commit;
          this.$refs.formOther.validate();
          $(".tab-pane").removeClass("show active");
          $(".tab-pane")
            .eq(3)
            .addClass("show active");
          $(".nav-link.tab").removeClass("active");
          $(".nav-link.tab")
            .eq(3)
            .addClass("active");
          return;
        } else {
          await this.saveIp(isDraft);
        }
      });
    },
    async saveIp(isDraft) {
      /* this.$refs.formSubmit.validate().then(success => {
        if (success) {

        }
      });*/
      this.processing = true;
      this.processing = false;

      const submitData = Object.assign({}, this.form);

      submitData.draft = isDraft;
      if (this.applyDate) {
        submitData.applyDate = new Date(this.applyDate).getTime();
      }
      if (submitData.id) {
        ideaCommon
          .updateIdea(submitData)
          .then(res => {
            if (res.data.success) {
              helper.successMsg("Cập nhật sáng kiến thành công");
              this.$router.push({ name: "MySubmission" });
            } else {
              helper.notifyError("Cập nhật sáng kiến thất bại!");
            }
          })
          .catch(error => {
            helper.notifyError(error);
          });
      } else {
        ideaCommon
          .createIdea(submitData)
          .then(res => {
            if (res.data.success) {
              helper.successMsg("Đăng kí sáng kiến thành công");
              this.$router.push({ name: "MySubmission" });
            } else {
              helper.notifyError("Đăng kí sáng kiến thất bại!");
            }
          })
          .catch(error => {
            helper.notifyError(error);
          });
      }
    },
    disabledTimeApply(ymd, date) {
      const now = new Date();
      if (now.getTime() - date.getTime() < 0) {
        return true;
      }

      if (date && this.monthDiff(date, now) > 12) {
        return true;
      }
    },
    monthDiff(d1, d2) {
      var months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      return months <= 0 ? 0 : months;
    },
    onUploadFileSuccess(file, response) {
      if (!response || response.length <= 0) {
        return;
      }

      response.forEach(result => {
        this.files.attachments = [
          ...this.files.attachments,
          { file, id: result.id }
        ];

        const uploadedFile = result;
        if (uploadedFile) {
          const id = uploadedFile.id;
          let { attachments } = this.form;
          if (attachments) {
            attachments += "," + id;
          } else {
            attachments += id;
          }
          this.form.attachments = attachments;
        }
      });
    },
    onRemoveFile(file, response, error, xhr) {
      if (file && file.id) {
        removeFile(file.id).then(resultRemove => {
          if (resultRemove.success) {
            let { attachments } = this.form;
            const ids = attachments.split(",");
            this.form.attachments = ids.filter(id => id != file.id).join(",");
          }
        });
        return;
      }

      const fileRemove = this.files.attachments.find(
        p => p.file.upload.uuid == file.upload.uuid
      );
      if (!fileRemove || !fileRemove.id) {
        return;
      }
      removeFile(fileRemove.id).then(resultRemove => {
        if (resultRemove.success) {
          let { attachments } = this.form;
          const ids = attachments.split(",");
          this.form.attachments = ids
            .filter(id => id != fileRemove.id)
            .join(",");
          this.files.attachments = this.files.attachments.filter(
            p => p.file.upload.uuid != file.upload.uuid
          );
        }
      });
    },
    onUploadSlideShowSuccess(file, response) {
      if (!response || response.length <= 0) {
        return;
      }
      response.forEach(result => {
        this.files.slideShows = [
          ...this.files.slideShows,
          { file, id: result.id }
        ];
        const uploadedFile = result;
        if (uploadedFile) {
          const id = uploadedFile.id;
          let { slideShow } = this.form;
          if (slideShow) {
            slideShow += "," + id;
          } else {
            slideShow += id;
          }
          this.form.slideShow = slideShow;
        }
      });
    },
    onRemoveSlideShow(file, response, error, xhr) {
      if (file && file.id) {
        removeFile(file.id).then(resultRemove => {
          if (resultRemove.success) {
            let { slideShow } = this.form;
            const ids = slideShow.split(",");
            this.form.slideShow = ids.filter(id => id != file.id).join(",");
          }
        });
        return;
      }
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    async getAllCompany() {
      try {
        let res = await axios.get(
          CONFIG.API_URL + "/company/search?pageNo=1&pageSize=1000"
        );
        return res.data.data.items;
      } catch (e) {
        console.error(e);
      }
    },
    async getFileInfos(list) {
      if (!list) {
        return;
      }
      const files = await getFileInfoList(list);
      return (
        (files &&
          files.length > 0 &&
          files.map(f => ({
            id: f.id,
            size: f.fileSize,
            name: f.fileName,
            type: f.mimeType
          }))) ||
        []
      );
    },
    checkFileIsImage(file) {
      if (file && file.type.match(/image\//)) {
        return true;
      }
      return false;
    },
    getUrlImage(file) {
      return `${CONFIG.API_URL}/image/${file.id}`;
    },
    setFileDropzone(file, target) {
      if (this.checkFileIsImage(file)) {
        this.$refs[target].manuallyAddFile(file, this.getUrlImage(file));
        this.$refs[target].dropzone.emit(
          "thumbnail",
          file,
          this.getUrlImage(file)
        );
        this.$refs[target].dropzone.emit("complete", file);
      } else {
        this.$refs[target].manuallyAddFile(file, "");
      }
    }
  }
};
</script>

<style scoped>
.new_submission_img {
  margin-top: 20px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #fff;
  position: relative;
}

#new_submission_detail {
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.new_submission_title {
  margin-top: 20px;
}

#new_submission_title_detail {
  font-size: 20px;
  font-weight: 600;
  text-align: left;
  color: #1e242f;
}

#new_submission_title_status {
  font-weight: bold;
  color: #e07254;
}

.form-submit .nav-pills a {
  padding: 14px 0 14px 0;
  font-weight: 600;
  color: #1e242f;
  position: relative;
}

.form-submit .nav-pills a .case_study_step {
  width: 33px;
  height: 33px;
  background-color: #3299ba;
  margin-right: 10px;
  color: #fff;
  font-size: 16px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-weight: bold;
}

.form-submit .nav-pills a .star_validate {
  color: red;
}

.form-submit .form-group {
  float: none;
}

.dropzone-custom-title {
  font-size: 14px;
}

.vue-dropzone {
  display: flex;
  justify-content: center;
  align-items: center;
}

.form-submit .nav-pills a.active .case_study_step {
  background-color: #3299ba;
  color: #fff;
}

.form-submit .nav-pills a:first-child:before {
  display: none;
}

.form-submit .nav-pills a.active ~ a::before {
  border-left: 2px dotted #e3e9f0;
}

.form-submit .nav-pills a.active ~ a span.case_study_step {
  background: #e3e9f0;
  color: #898e97;
}

.form-submit .nav-pills a::before {
  border-left: 2px dotted #3299ba;
  display: block;
  content: "";
  height: 18px;
  width: 1px;
  position: absolute;
  left: 16px;
  top: -10px;
}

.form-submit .nav-pills a.active::before {
  border-left: 2px dotted #3299ba;
}

.form-submit .nav-pills a.active {
  color: #3299ba;
  background: transparent;
}

.form-submit .form-right {
  border: solid 1px #c7ced5;
}

.form-submit .form-right .form-body {
  padding-left: 30px;
  padding-right: 30px;
}

.form-submit .form-right .form-control-top {
  border-bottom: solid 1px #c7ced5;
  text-align: right;
  padding-top: 15px;
  padding-bottom: 15px;
}

.form-submit .form-right .form-control-top button {
  border-radius: 18px;
  background-color: #fff;
  border: 1px solid #3299ba;
  font-size: 12px;
  font-weight: normal;
  color: #3199bb;
  padding: 5px 30px;
  margin-right: 20px;
}

.form-submit .form-right .form-control-top button:hover {
  background-color: #3299ba;
  border: 1px solid #3299ba;
  color: #fff;
}

.form-submit .form-right .form-control-top button.btn-primary {
  border-radius: 21px;
  background-color: #3199bb;
  font-size: 12px;
  font-weight: normal;
  color: #ffffff;
  border: 1px solid #3199bb;
  padding: 5px 50px;
}

.form-submit .form-right .form-control-top button.btn-primary:hover {
  background-color: #ffffff;
  color: #3199bb;
  border: 1px solid #3199bb;
}

/* .form-submit .form-right .form-group input {
  border: solid 1px #c7ced5;
} */

.sku_sub_form_title {
  font-size: 12px;
  font-weight: bold;
  color: #3299ba;
  padding-bottom: 5px;
  border-bottom: 1px dotted #3299ba;
  margin-bottom: 20px;
  padding-left: 0;
}

.form-check label {
  font-weight: normal !important;
}

.date-control,
.date-input {
  height: 38px;
  width: 100%;
}

.form-control {
  font-size: 14px !important;
}

.vue-dropzone {
  display: flex;
  justify-content: center;
  align-items: center;
}

.note {
  font-size: 14px;
  font-weight: 400;
}

.commit {
  color: #4dbd74;
}
</style>

<style >
.date-input {
  border: solid 1px #c7ced5;
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 0.25rem;
}

.date-input:focus {
  border: solid 1px #c7ced5;
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.b-form-datepicker.is-invalid,
.b-form-datepicker.is-valid {
  background-image: none !important;
  padding-right: 0 !important;
}

.content-web{
  min-height: 86.9vh;
}
</style>




// WEBPACK FOOTER //
// src/components/common/IpForm.vue